module.exports = __webpack_public_path__ + "img/lafd-logo.a5afec6b.png";